{
  "name": "goomi-user-front",
  "version": "0.4.14",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration development",
    "start:local": "ng serve --configuration local",
    "start:prod": "ng serve --configuration production",
    "build": "ng build --configuration development",
    "build:staging": "ng build --configuration staging",
    "build:development": "ng build --configuration development",
    "build:production": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test-headless": "ng test --no-watch --no-progress --browsers=ChromeHeadless",
    "lint:fix": "ng lint --fix",
    "test": "ng test",
    "lint": "ng lint",
    "prepare": "husky"
  },
  "private": true,
  "engines": {
    "node": ">=26.12.1"
  },
  "overrides": {
    "jwa": "^1.4.2"
  },
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.6",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/material": "^18.2.6",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@ngrx/effects": "^18.0.2",
    "@ngrx/entity": "^18.0.2",
    "@ngrx/store": "^18.0.2",
    "@ngrx/store-devtools": "^18.0.2",
    "@sentry/angular": "^10.12.0",
    "@silvermine/videojs-chromecast": "^1.5.0",
    "@stripe/stripe-js": "^4.9.0",
    "@types/lodash-es": "^4.17.12",
    "@wlcm/angular": "^18.2.25",
    "@wlcm/common": "^1.0.1",
    "@zoom/meetingsdk": "^3.12.0",
    "branch-sdk": "^2.87.1",
    "cropperjs": "^1.6.2",
    "hammerjs": "^2.0.8",
    "heic2any": "^0.0.4",
    "lodash-es": "^4.17.21",
    "ngx-stripe": "^18.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "video.js": "^8.19.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.5",
    "@angular/cli": "^18.2.5",
    "@angular/compiler-cli": "^18.2.0",
    "@ngrx/eslint-plugin": "^18.0.2",
    "@types/branch-sdk": "^2.53.7",
    "@types/cropperjs": "^1.3.3",
    "@types/hammerjs": "^2.0.46",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^26.6.5",
    "@types/video.js": "^7.3.58",
    "angular-eslint": "18.3.1",
    "eslint": "^9.9.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.2.1",
    "husky": "^9.1.6",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.10",
    "prettier": "^3.3.3",
    "prettier-eslint": "^16.3.0",
    "typescript": "~5.5.2",
    "typescript-eslint": "8.2.0"
  }
}
